// getLiveStreamPrice.js
'use strict';
import { LIVESTREAM_PRIVATE_PRICE_VALUE } from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

/**
 * Select live stream price by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @param {string} preset - stream preset.
 * @return {number} The selected live stream price.
 */
const getLiveStreamPrice = createCachedSelector(
  (state, streamId, preset) =>
    getLiveStreamData(state, [streamId, 'presets', preset], 'price'),
  state => getRemoteConfigData(state, LIVESTREAM_PRIVATE_PRICE_VALUE),
  (defaultPrice, privatePrice) => {
    return privatePrice != null ? privatePrice : defaultPrice;
  }
)((state, streamId, preset) => `${streamId}:${preset}`);

/**
 * Select live stream exclusive private price by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {number} The selected live stream price.
 */
export const getLiveStreamExclusivePrivatePrice = createCachedSelector(
  (state, streamId) =>
    getLiveStreamData(state, [streamId, 'settings'], 'exclusivePrice'),
  exclusivePrice => {
    return exclusivePrice;
  }
)((state, streamId) => `${streamId}`);

export default getLiveStreamPrice;
